/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateTaskItemAreaDto } from './CreateOrUpdateTaskItemAreaDto';
import {
    CreateOrUpdateTaskItemAreaDtoFromJSON,
    CreateOrUpdateTaskItemAreaDtoFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoToJSON,
} from './CreateOrUpdateTaskItemAreaDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface CreateOrUpdateTaskItemDto
 */
export interface CreateOrUpdateTaskItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CreateOrUpdateTaskItemAreaDto>}
     * @memberof CreateOrUpdateTaskItemDto
     */
    taskItemAreas?: Array<CreateOrUpdateTaskItemAreaDto> | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateOrUpdateTaskItemDto
     */
    category?: RtSystemCategory;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateOrUpdateTaskItemDto
     */
    subCategory?: MedicalSystemSubCategory;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof CreateOrUpdateTaskItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdateTaskItemDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateTaskItemDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemDto
     */
    $type?: CreateOrUpdateTaskItemDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateTaskItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateTaskItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateTaskItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateTaskItemDtoTypeEnum = typeof CreateOrUpdateTaskItemDtoTypeEnum[keyof typeof CreateOrUpdateTaskItemDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateTaskItemDto interface.
 */
export function instanceOfCreateOrUpdateTaskItemDto(value?: unknown): value is CreateOrUpdateTaskItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateTaskItemDtoTypeEnum)[0];
}

export function CreateOrUpdateTaskItemDtoFromJSON(json: any): CreateOrUpdateTaskItemDto {
    return CreateOrUpdateTaskItemDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'taskItemAreas': !exists(json, 'taskItemAreas') ? undefined : (json['taskItemAreas'] === null ? null : (json['taskItemAreas'] as Array<any>).map(CreateOrUpdateTaskItemAreaDtoFromJSON)),
        'category': !exists(json, 'category') ? undefined : RtSystemCategoryFromJSON(json['category']),
        'subCategory': !exists(json, 'subCategory') ? undefined : MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdateTaskItemDtoToJSON(value?: CreateOrUpdateTaskItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'taskItemAreas': value.taskItemAreas === undefined ? undefined : (value.taskItemAreas === null ? null : (value.taskItemAreas as Array<any>).map(CreateOrUpdateTaskItemAreaDtoToJSON)),
        'category': RtSystemCategoryToJSON(value.category),
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value.isAvailable,
        'lastModificationTime': value.lastModificationTime,
        '$type': value.$type,
    });
}

